import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from './firebase'
import VueSweetalert2 from 'vue-sweetalert2';
import vuetify from './plugins/vuetify';
import './assets/scss/app.scss'
// import './../node_modules/bulma/css/bulma.css';
// import 'sweetalert2/dist/sweetalert2.min.css';
import VueLazyload from 'vue-lazyload'
import VueWorker from 'vue-worker';

Vue.use(VueSweetalert2);
Vue.use(VueLazyload);
Vue.use(VueWorker);

Vue.config.productionTip = false

let app
auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }

  if (user) {
    store.dispatch('fetchUserProfile', user)
  }
})
